export default __webpack_public_path__ + "static/media/publicholidays.4f3615db.svg";